<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			
			<!-- 
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		
		<div  class="lb">
			<div class="query">
					<div class="checkbox">
						<input v-model="begin" type="number" placeholder="开始id" />-
						<input v-model="over" type="number" placeholder="结束id"/>
						<Button type="primary" @click="add">生产小程序码</Button>
					</div>
				<Input search enter-button placeholder="请输入地址/名称查询"  v-model="query.like" style="width: 500px;" @on-search="onsearch" />
			</div>
			<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
				<template slot-scope="{ row, index }" slot="action">
					<Button size="small" style="margin-right: 5px" @click="shengchan(row.id)" type="primary">重新生成</Button>
					
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				begin:'',
				over:'',
				loading: false,
				total: 100,
				query: {
					page: 0,
					size: 10,
					id: '' ,//加盟商id
					like:'',
					macKind:'',
					regionId:'',
					startUsing:'',
					state:'',
				},
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					}, {
						title: '编号',
						key: 'macCode'
					},
					{
						title: '所属加盟商',
						key: 'alliance',
						render: (h, params) => {
								return h("div", params.row.alliance.companyName)
						}
					},
					{
						title: '名称',
						key: 'macDetailsName'
					},
					{
						title: '名称',
						key: 'deviceName'
					},
					{
						title: '分类',
						key: 'macKindstString'
					},
					{
						title: '位置',
						key: 'address'
					},
					{
						title: '停用/启用',
						key: 'startUsing',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div",{style:{color:'red'}},"停用") 
							}
						}
					},
					{
						title: '是否故障',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div",{style:{color:'red'}},"故障") 
							}
						}
					},
					{
						title: '状态',
						key: 'macContractStateString',
						render: (h, params) => {
							if (params.row.macContractStateName == 'WC') {
								return h("div", {style:{color:'green'}},params.row.macContractStateString)
							} else if(params.row.macContractStateName == 'YC') {
								return h("div",{style:{color:'red'}},params.row.macContractStateString) 
							} else{
								return h("div",{style:{color:'blue'}},params.row.macContractStateString) 
							}
						}
					},
					{
						title: '货道总数',
						key: 'total'
					},
					{
						title: '未分配数',
						key: 'isNull'
					},
					{
						title: '已分配数',
						key: 'isNotNull'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [],

			}
		},
		methods: {
			
			ret() { //返回上一页
				this.$router.go(-1)
			},
			add(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/generateQrCode',
				    data: {
						begin:_this.begin,
						over:_this.over
					},
					_this: _this,
					success: function(data) {
						
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onchange(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/allianceAll',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading = false
						_this.total = data.macLeaveFactorys.totalElements
						_this.data6 = data.macLeaveFactorys.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		    shengchan(id){
				
			}
		},
		components: {
			page
		},
		created() {
			this.ajaxPage()
			//this.ajaxPageDitu()
			
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/mac/list.vue